import React, { Component } from 'react';
import Loading from 'components/Loading';
import Navbar from '../../layouts/public-navbar/NavBarDS';
import Footer from '../../layouts/public-footer/Footer';
import { Helmet } from 'react-helmet';
import * as moment from 'moment-jalaali';
import { Link } from 'react-router-dom';
import ProfileSidebar from 'layouts/profile-sidebar/ProfileSidebar';
import ReactHtmlParser from 'react-html-parser';
import * as Scroll from 'react-scroll';

import './NotificationsStyle.scss'


export default class NotificationsPage extends Component {
    constructor(props) {
        super(props);
        this.makePageController = this.makePageController.bind(this);
        this.increaseCurrentPage = this.increaseCurrentPage.bind(this);
        this.decreaseCurrentPage = this.decreaseCurrentPage.bind(this);
        this.clickNotificationHandler = this.clickNotificationHandler.bind(this)
        this.notifClassHandler = this.notifClassHandler.bind(this)
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        this.props.initData()
    }

    increaseCurrentPage() {
        if (!(this.props.currentPage === this.props.totalPages)) {
            this.props.changeCurrentPage(this.props.currentPage + 1);
        }
    }

    decreaseCurrentPage() {
        if (!(this.props.currentPage === 1)) {
            this.props.changeCurrentPage(this.props.currentPage - 1);
        }
    }

    clickNotificationHandler(notif) {
        if (notif.is_seen === false && notif.post === null) {
            this.props.initData()
        } else if (notif.post != null) {
            this.props.history.push(
                `/execute/program/${notif.post.program_uid}/course/${notif.post.course_uid}/forum/topic/${notif.post.topic_uid}/discussion/${notif.post.discussion_uid}/post/${notif.post.uid}`
            )
        }
    }

    notifClassHandler(notif) {
        if (notif.is_seen === false) {
            return "new-notif-item"
        }
        if (notif.post != null) {
            return "post-notif-item"
        }else if (notif.is_seen === true) {
            return "notif-item"
        }
    }

    makePageController() {
        return (<div className="next-notif-pages">
            <span className="notifs-count">{this.props.notifsCount} اعلان</span>
            {
                this.props.currentPage !== 1 ? (
                    <span className='back-btn' onClick={this.decreaseCurrentPage}><img className='arrow-back' src={"/images/outline-arrow_back1.svg"} />  صفحه قبلی </span>
                ) : (
                        // <span className='back-btn-inactive' onClick={this.decreaseCurrentPage}><img className='arrow-back' src={"/images/outline-arrow_back-24px.svg"} />  صفحه قبلی </span>
                        null
                    )
            }
            {!this.props.totalPages === 1? (
                <i> {this.props.currentPage}/{this.props.totalPages}</i>
            ): (
                null
            )}
            {
                !(this.props.currentPage === this.props.totalPages) ? (
                    <span className='next-btn' onClick={this.increaseCurrentPage}>صفحه بعدی <img className="arrow-next" src={"/images/outline-arrow_next.svg"} /> </span>
                ) : (
                        // <span className='next-btn-inactive' onClick={this.increaseCurrentPage}>صفحه بعدی <img className="arrow-next" src={"/images/outline-arrow_back-24px-gray.svg"} /> </span>
                        null
                    )
            }
        </div>)
    }

    makeNotificationsCard() {
        if (this.props.notifications.length === 0) {
            return (
                <ul>
                    <p className="no-notif">هیچ اعلانی وجود ندارد</p>
                </ul>
            )
        }
        return this.props.notifications.map((notif, index) => {
            return (
                <div onClick={() => this.clickNotificationHandler(notif)} className={this.notifClassHandler(notif)}>
                    <ul>
                        <li className="notif-body">{ReactHtmlParser(notif.notification_body)}</li>
                        {notif.is_seen === false ? (
                        <li className="new-notif">
                            جدید
                        </li>
                        ): (
                            null
                        )}
                        <li className="notif-time-li">
                            <span className="notif-time">{moment(notif.actual_send_date).fromNow()} <img className="l-notif-time" src={"/images/outline-access_time.svg"} /></span>
                        </li>
                    </ul >
                </div>
            )
        })
    }
    render() {
        if (this.props.showSpinner) {
            return (
                <div id="notifs-list-page"> 
                    <Navbar />
                    <Loading />
                    <Footer />
                </div>
            )
        }

        return (
            <div id="notifs-list-page">
                <Helmet>
                    <title>آکادمی درایت- اعلانات</title>
                </Helmet>
                <Navbar />
                <div className="notif-list clearfix">
                    <ProfileSidebar />
                    <div className="notif-list-right">
                        <div className="notif-header">
                            <span id="notif-box-title">
                                <b> اعلانات</b>
                            </span>
                        </div>
                        <div className="my-notif-list">
                            {this.makeNotificationsCard()}
                        </div>
                        {
                            this.props.notifications.length != 0 ? (
                                this.makePageController()
                            ) : (
                                    null
                                )
                        }
                    </div>
                </div>
                <Footer />
            </div>
        )
    }

}
